// Chhattisgarh — 33 जिले + प्रमुख ब्लॉक/तहसील
export const CG_DISTRICTS = {
  "सूरजपुर": ["सूरजपुर", "प्रतापपुर", "प्रेमनगर", "ओड़गी", "भैयाथान", "रामानुजनगर"],
  "सरगुजा (अंबिकापुर)": ["अंबिकापुर", "लखनपुर", "उदयपुर", "सीतापुर", "मैनपाट", "बतौली", "लुण्ड्रा"],
  "बलरामपुर": ["बलरामपुर", "रामानुजगंज", "वाड्रफनगर", "कुसमी", "शंकरगढ़", "राजपुर"],
  "जशपुर": ["जशपुर", "कुनकुरी", "बगीचा", "पत्थलगांव", "कांसाबेल", "मनोरा", "फरसाबहार"],
  "कोरिया (बैकुण्ठपुर)": ["बैकुण्ठपुर", "सोनहत", "खड़गवां", "मनेन्द्रगढ़"],
  "मनेन्द्रगढ़-चिरमिरी-भरतपुर": ["मनेन्द्रगढ़", "चिरमिरी", "भरतपुर", "जनकपुर"],
  "रायपुर": ["रायपुर", "अभनपुर", "आरंग", "तिल्दा", "धरसीवा"],
  "बिलासपुर": ["बिलासपुर", "कोटा", "मस्तूरी", "तखतपुर", "बिल्हा"],
  "दुर्ग": ["दुर्ग", "पाटन", "धमधा"],
  "राजनांदगांव": ["राजनांदगांव", "डोंगरगढ़", "डोंगरगांव", "छुरिया", "अंबागढ़ चौकी"],
  "कोरबा": ["कोरबा", "कटघोरा", "पाली", "करतला", "पोंडी उपरोड़ा"],
  "जांजगीर-चांपा": ["जांजगीर", "चांपा", "पामगढ़", "अकलतरा", "बलौदा", "नवागढ़"],
  "रायगढ़": ["रायगढ़", "पुसौर", "खरसिया", "घरघोड़ा", "तमनार", "लैलूंगा", "धरमजयगढ़"],
  "बस्तर (जगदलपुर)": ["जगदलपुर", "बकावंड", "तोकापाल", "दरभा", "बास्तानार", "बस्तर", "लोहंडीगुड़ा"],
  "कांकेर": ["कांकेर", "चारामा", "भानुप्रतापपुर", "अंतागढ़", "कोयलीबेड़ा", "नरहरपुर"],
  "कोंडागांव": ["कोंडागांव", "फरसगांव", "बड़ेराजपुर", "केशकाल", "माकड़ी"],
  "दंतेवाड़ा": ["दंतेवाड़ा", "गीदम", "कुआकोंडा", "कटेकल्याण"],
  "सुकमा": ["सुकमा", "कोंटा", "छिंदगढ़"],
  "बीजापुर": ["बीजापुर", "भोपालपटनम", "उसूर", "भैरमगढ़"],
  "नारायणपुर": ["नारायणपुर", "ओरछा"],
  "कबीरधाम (कवर्धा)": ["कवर्धा", "पंडरिया", "स.लो.मरो", "बोड़ला"],
  "मुंगेली": ["मुंगेली", "पथरिया", "लोरमी"],
  "बालोद": ["बालोद", "गुरुर", "गुंडरदेही", "डौंडी", "डौंडीलोहारा"],
  "बेमेतरा": ["बेमेतरा", "साजा", "बेरला", "नवागढ़"],
  "धमतरी": ["धमतरी", "कुरुद", "मगरलोड", "नगरी"],
  "गरियाबंद": ["गरियाबंद", "छुरा", "फिंगेश्वर", "मैनपुर", "देवभोग"],
  "महासमुंद": ["महासमुंद", "बागबाहरा", "पिथौरा", "सरायपाली", "बसना"],
  "बलौदा बाजार": ["बलौदा बाजार", "भाटापारा", "पलारी", "सिमगा", "बिलाईगढ़", "कसडोल"],
  "गौरेला-पेंड्रा-मरवाही": ["गौरेला", "पेंड्रा", "मरवाही"],
  "सक्ती": ["सक्ती", "जैजैपुर", "मालखरौदा", "डभरा"],
  "सारंगढ़-बिलाईगढ़": ["सारंगढ़", "बरमकेला", "बिलाईगढ़"],
  "मोहला-मानपुर-अंबागढ़ चौकी": ["मोहला", "मानपुर", "अंबागढ़ चौकी"],
  "खैरागढ़-छुईखदान-गंडई": ["खैरागढ़", "छुईखदान", "गंडई"],
};

export const CG_DISTRICT_LIST = Object.keys(CG_DISTRICTS);
